/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BlockIcon24Solid = forwardRef('BlockIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.75C6.34 1.75 1.75 6.339 1.75 12c0 5.66 4.59 10.25 10.25 10.25S22.25 17.66 22.25 12c0-5.661-4.59-10.25-10.25-10.25ZM7.475 5.707a7.75 7.75 0 0 1 10.817 10.817L7.476 5.708ZM5.707 7.475a7.75 7.75 0 0 0 10.818 10.818L5.707 7.475Z" })));
});
